import * as React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';

import { useQuery } from '../../../components/common/useQuery';
import { useAuth } from '../../../common/hooks/useAuth';
import { ClipLoader } from 'react-spinners';
import { Box } from '@mui/material';

const SignupSuccess: React.FunctionComponent = () => {
    const { setAuthentication, loading, authenticated, performRegisteredLogin } = useAuth()
    const navigate = useNavigate()
    const query = useQuery()
    const sessionId = query.get('session_id') || ''

    React.useEffect(() => {
        if (authenticated || !sessionId || loading) {
            return
        }

        const onPerformRegisteredLogin = async () => {
            const { success } = await performRegisteredLogin(sessionId);

            if (!success) {
                navigate('/')
            } else {
                navigate('/guide')
            }
        }

        onPerformRegisteredLogin()
    }, [sessionId, loading, setAuthentication])
    
    if (!sessionId || authenticated) {
        return <Navigate to="/" />
    }
    
    return (
        <Box sx={{ display: 'flex', height: '50rem', marginTop: '8rem', alignItems: 'center', justifyContent: 'center' }}>
            <ClipLoader />
        </Box>
    );
}

export default SignupSuccess